import { render, staticRenderFns } from "./WarehouseMaterial.vue?vue&type=template&id=463e76c3&scoped=true&"
import script from "./WarehouseMaterial.vue?vue&type=script&lang=js&"
export * from "./WarehouseMaterial.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseMaterial.vue?vue&type=style&index=0&id=463e76c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e76c3",
  null
  
)

export default component.exports